/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { DailyRateDto, GetRateParams } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiRateController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-rate-controller
   * @name GetRate
   * @request GET:/api/v1/rate
   */
  getRate = (query: GetRateParams, params: RequestParams = {}) =>
    this.http.request<DailyRateDto, any>({
      path: `/v1/rate`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getRatePath = '/v1/rate'
  static getRateMethod = 'GET'
}
